import { useMemo } from 'react';
import { USER_TYPE_SUPER_ADMIN } from 'src/config-global';
import { useGetUserProfileQuery } from 'src/store/Reducer/settings';
import { useMockedUser } from './use-mocked-user';

// Single source of truth for the signed-in user's profile on the Account screens.
// Redux (`useMockedUser`) supplies identity/token; the Get Profile API supplies the
// always-fresh, fully-qualified values (name, image, phone, company + logo). The API
// response is cached under the "Profile" RTK tag, so saving a profile/company change
// invalidates it and every consumer refetches once.
export function useProfile() {
  const { user } = useMockedUser();

  const role = user?.user_type === USER_TYPE_SUPER_ADMIN ? 'admin' : 'contractor';

  const { data, isLoading, isFetching, refetch } = useGetUserProfileQuery(
    { role },
    { skip: !user?._id }
  );

  const body = data?.body;

  const profile = useMemo(
    () => ({
      ...user,
      ...(body || {}),
      // keep the field names the profile/avatar components expect
      displayName: body?.name ?? user?.displayName,
      photoURL: body?.image ?? user?.photoURL ?? user?.image,
    }),
    [user, body]
  );

  return { profile, role, isLoading, isFetching, refetch, raw: body };
}
